<div class="container-fluid">
  <div class="grid" style="padding-top:0.5rem">
    <mat-icon class="pageTitleIcon">list</mat-icon>
    <h2 class="pageTitleHeader">Aufgaben</h2>
    <i name="neueaufgabe" class="pi pi-plus pageAddButtonIcon" (click)="openTaskEditDialog('master', 'new')" pTooltip="Neue Aufgabe anlegen"></i>
  </div>
  <div class="contentSeperator"></div>
  <div class="row filterPanel grid">
    <div class="col-1">Filter:</div>
    <div class="col-1"><p-checkbox  name="selectedFilters0" [value]="0" id="Alle" [(ngModel)]="selectedCategories" (onChange)="selectedAllCategories()"></p-checkbox>
    <label class="ml-2" for="Alle" >Alle</label>
  </div>
  <div class="col-1"><p-checkbox name="selectedFilters1" [value]="100" id="Erstellt" [(ngModel)]="selectedCategories" (onChange)="selectSpecificCategory()"></p-checkbox>
  <label class="ml-2" for="Erstellt" >Erstellt</label>
</div>
<div class="col-1"><p-checkbox name="selectedFilters2" [value]="200" id="Freigegeben" [(ngModel)]="selectedCategories" (onChange)="selectSpecificCategory()"></p-checkbox>
<label class="ml-2" for="Freigegeben" >Freigegeben</label>
</div>
<div class="col-1"><p-checkbox name="selectedFilters3" [value]="300" id="InArbeit" [(ngModel)]="selectedCategories" (onChange)="selectSpecificCategory()"></p-checkbox>
<label class="ml-2" for="inArbeit" >In Arbeit</label>
</div>
<div class="col-1"><p-checkbox name="selectedFilters4" [value]="500" id="Übermittelt" [(ngModel)]="selectedCategories" (onChange)="selectSpecificCategory()"></p-checkbox>
<label class="ml-2" for="Übermittelt" >Übermittelt</label>
</div>
<div class="col-1"><p-checkbox name="userFilter" [binary]="true" id="NurEigene" [(ngModel)]="showOwnTasksOnly" (onChange)="selectOwnTasks()"></p-checkbox>
<label class="ml-2" for="NurEigene" >Nur Eigene</label>
</div>
<div class="col-1"><p-checkbox name="archivFilter" [value]="700" id="Archiv" [(ngModel)]="selectedCategories" (onChange)="selectSpecificCategory()"></p-checkbox>
<label class="ml-2" for="Archiv" >Archiv</label>
</div>
<div class="col-2">
  <p-select id="aufgabenart" [options]="aufgabenArten"  [(ngModel)]="selectedAufgabenart" showClear="true"
    (onClear)="selectAufgabenart()"
  optionLabel="value"  placeholder="Aufgabenart filtern" (ngModelChange)="selectAufgabenart()" >      </p-select>
</div>
</div>
<div class="row filterPanel grid">
  <div class="col-1">Sortierung:</div>
  <div class="col">
    <p-select
      [options]="orderTaskOptions"
      optionLabel = "value"
      optionValue = "key"
      [(ngModel)]="selectedOrderTaskOption"
      appendTo = "body"
      (onChange)="onSelectedOrderTaskOptionChanged($event.value)">
    </p-select>
  </div>
</div>
<div class="contentSeperator"></div>
<p-treeTable #taskList [value]="tasks()" [columns]="userCols" [resizableColumns]="true"
  [rows]="this.pageSorting.rowsToLoad"
  class=""
  [showGridlines]="true"
  [lazy]="true" (onLazyLoad)="loadTaskData($event)"
  [lazyLoadOnInit]="false"
  [totalRecords]="total$ | async"
  paginatorDropdownAppendTo="body"
  [first]="pageSorting.skipRows"
  [paginator]="true"
  [pageLinks]="3"
  [rowsPerPageOptions]="[20,50,100]"
  [showCurrentPageReport]="true"
  [currentPageReportTemplate]="'{first} bis {last} von {totalRecords} Aufgaben'"
  [rowHover]="true"
  >
  <ng-template pTemplate="header" let-columns>
    <tr >
      @if (isManager) {
        <th [ngClass]="'kb-header-cell-medium'"></th>
      }
      <th [ngClass]="'kb-header-cell-small'"></th>
      <th [ngClass]="'kb-header-cell-small'"></th>
      <th [ngClass]="'kb-header-cell-small'"></th>
      @for (col of columns; track col) {
        <th [ttSortableColumn]="col.field"  ttResizableColumn
          [style]="getHeaderStyle(col?.field)"
          [ngClass]="'kb-header-cell-default'"  [ttSortableColumnDisabled]="!col.canOrder" >
          {{col.header}}
          @if (col.canOrder) {
            <p-treeTableSortIcon  [field]="col.field"></p-treeTableSortIcon>
          }
        </th>
      }
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
    <tr  [ttRow]="rowNode"  [ngClass]="getUserTaskClass('kb-row', rowData)"  >
      @if (rowData.userId == null) {
        <td [ngClass]="getUserTaskClass('kb-cell-small', rowData)">
          <div>
            <span class="badge badge-success badge-new" pTooltip="Erstellt">{{ getTaskCount(rowNode.node.children, "created") }}</span>
            <span class="badge badge-success badge-none" pTooltip="Freigegeben">{{ getTaskCount(rowNode.node.children, "new") }}</span>
            <span class="badge badge-success badge-ongoing" pTooltip="In Arbeit">{{ getTaskCount(rowNode.node.children, "ongoing") }}</span>
            <!-- <span class="badge badge-success badge-done" pTooltip="Fertiggestellt">{{ getTaskCount(rowNode.node.children, "done") }}</span> -->
            <span class="badge badge-success badge-transfered"  pTooltip="Übermittelt">{{ getTaskCount(rowNode.node.children, "transfered") }}</span>
          </div>
        </td>
      }
      @if (rowData.userId == null) {
        <td [ngClass]="getUserTaskClass('kb-cell-small', rowData)">
          <i  id="addtaskforsupplier" class="pi pi-plus treeTableButton" (click)="createTasksForSuppliersShort( rowData, rowNode.node)"></i>
        </td>
      }
      @if (rowData.userId == null) {
        <td #thistd [ngClass]="getUserTaskClass('kb-cell-small', rowData)">
          <p-contextMenu [triggerEvent]="'click'" [id]="rowData.id"  #masterMenu [target]="masterActions" [model]="currentmainMenu()"
            appendTo="body" (onHide)="hideMainMenue(rowData, rowNode.node, masterMenu)"
          (onShow)="setSelectedTreeNode(rowData, rowNode.node, masterMenu )"></p-contextMenu>
          <i #masterActions (click)="toggle($event, masterMenu)" class="pi pi-ellipsis-h treeTableButton"></i>
        </td>
      }
      @if (rowData.userId != null) {
        <td [ngClass]="getUserTaskClass('kb-cell-small', rowData)"></td>
      }
      @if (rowData.userId == null) {
        <td [ngClass]="getUserTaskClass('kb-cell-small', rowData)">
          @if (rowNode.node.children?.length > 0) {
            <p-treeTableToggler [rowNode]="rowNode" ></p-treeTableToggler>
          }
        </td>
      }
      @if (rowData.userId != null) {
        <td [ngClass]="getUserTaskClass('kb-cell-small', rowData)"></td>
      }
      @if (rowData.userId != null) {
        <td [ngClass]="getUserTaskClass('kb-cell-small', rowData)"></td>
      }
      @if (rowData.userId != null) {
        <td [ngClass]="getUserTaskClass('kb-cell-small', rowData)">
          @if (hasChildMenus(rowNode.node.data)) {
            <div>
              <p-contextMenu [triggerEvent]="'click'" #childmenu [id]="rowNode.node.data.id" [target]="childActions" [model]="currentchildMenu()"
                (onHide)="hideChildMenu(rowData, rowNode.node, childmenu)"
              appendTo="body"     (onShow)="setSelectedTreeItem(rowData, rowNode.node.data, childmenu)"></p-contextMenu>
              <i  (click)="toggle($event, childmenu)" #childActions class="pi pi-ellipsis-h treeTableButton"></i>
            </div>
          }
        </td>
      }
      <!-- TODO: Wird nicht verwendet -->
      @if ((!rowData.uploadState || rowData.uploadState < 20) && showUpload == true) {
        <td [ngClass]="'kb-cell-small'">
          <button pButton  type="button" icon="pi pi-paperclip" styleClass="p-button-info" (click)='openUpload(rowData)'
          pTooltip="Upload ansehen" tooltipPosition="top" showDelay="1000" hideDelay="1000"></button>
        </td>
      }
      @if (rowData.uploadState && rowData.uploadState >= 20 && showUpload == true) {
        <td [ngClass]="'kb-cell-small'">
          <div ><i class="pi pi-check"></i></div>
        </td>
      }


      <td [style]="getHeaderStyle('name')" [ngClass]="getUserTaskClass('kb-cell-default', rowData)">{{rowData.name}}</td>
      <td [ngClass]="getUserTaskClass('kb-cell-default', rowData)">{{getAufgabenArtText(rowData.aufgabenArt)}}</td>
      <td [style]="getHeaderStyle('sortimentName')" [ngClass]="getUserTaskClass('kb-cell-default', rowData)">{{rowData.sortimentName}}</td>
      <td [ngClass]="getUserTaskClass('kb-cell-default', rowData)">{{rowData.taskValidRangeFrom | date}}</td>
      <td [ngClass]="getUserTaskClass('kb-cell-default', rowData)">{{rowData.taskValidRangeTo | date}}</td>
      @if (isManager) {
        <td [ngClass]="getUserTaskClass('kb-cell-default', rowData)">{{rowData.organization}}</td>
      }
      @if (isManager) {
        <td [ngClass]="getUserTaskClass('kb-cell-default', rowData)">{{ getPartner(rowData.lastName, rowData.firstName) | shorten: 20: '...': true}}</td>
      }
      @if (!isManager) {
        <td [ngClass]="getUserTaskClass('kb-cell-default', rowData)">{{rowData.creatorFriendlyName | shorten: 15: '...'}}</td>
      }
      @if (!isManager) {
        <td [ngClass]="getUserTaskClass('kb-cell-default', rowData)">{{rowData.creatorMail | shorten: 15: '...': true}}</td>
      }
    </tr>
  </ng-template>
</p-treeTable>
</div>

<p-confirmDialog header="Bitte bestätigen:" icon="pi pi-exclamation-triangle" message="Keine Zeilen werden gelöscht." rejectLabel="Abbrechen"></p-confirmDialog>
<p-toast id="tasklisttoasterSuccess"  key="successtasklistMessage"></p-toast>
<p-toast id="tasklisttoasterError"  key="errortasklistMessage"></p-toast>
